import { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { has, isArray } from "lodash";

import { toast } from "react-toastify";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { SocketContext } from "../../context/Socket/SocketContext";
import moment from "moment";
const useAuth = () => {
  const history = useHistory();
  const [isAuth, setIsAuth] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState({});

  api.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers["Authorization"] = `Bearer ${JSON.parse(token)}`;
        setIsAuth(true);
      }
      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );

  api.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const originalRequest = error.config;
      if (error?.response?.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;

        const { data } = await api.post("/auth/refresh_token");
        if (data) {
          localStorage.setItem("token", JSON.stringify(data.token));
          api.defaults.headers.Authorization = `Bearer ${data.token}`;
        }
        return api(originalRequest);
      }
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("companyId");
        api.defaults.headers.Authorization = undefined;
        setIsAuth(false);
      }
      return Promise.reject(error);
    }
  );

  const socketManager = useContext(SocketContext);

  useEffect(() => {
    const token = localStorage.getItem("token");
    (async () => {
      if (token) {
        try {
          const { data } = await api.post("/auth/refresh_token");
          api.defaults.headers.Authorization = `Bearer ${data.token}`;
          setIsAuth(true);
          setUser(data.user);
        } catch (err) {
          toastError(err);
        }
      }
      setLoading(false);
    })();
  }, []);

  useEffect(() => {
    const companyId = localStorage.getItem("companyId");
    if (companyId) {
   
      const socket = socketManager.getSocket(companyId);

      socket.on(`company-${companyId}-user`, (data) => {
        if (data.action === "update" && data.user.id === user.id) {
          setUser(data.user);
        }
      });
    
    
    return () => {
      socket.disconnect();
    };
  }
  }, [socketManager, user]);

  const handleLogin = async (userData) => {
    setLoading(true);

    try {
      const { data } = await api.post("/auth/login", userData);
      const {
        user: { companyId, id, company },
      } = data;

      if (has(company, "settings") && isArray(company.settings)) {
        const setting = company.settings.find(
          (s) => s.key === "campaignsEnabled"
        );
        if (setting && setting.value === "true") {
          localStorage.setItem("cshow", null); //regra pra exibir campanhas
        }
      }

      moment.locale('pt-br');
      const dueDate = data.user.company.dueDate;
      const hoje = moment(moment()).format("DD/MM/yyyy");
      const vencimento = moment(dueDate).format("DD/MM/yyyy");

      var diff = moment(dueDate).diff(moment(moment()).format());

      var before = moment(moment().format()).isBefore(dueDate);
      var dias = moment.duration(diff).asDays();

      if (before === true) {
        localStorage.setItem("token", JSON.stringify(data.token));
        localStorage.setItem("companyId", companyId);
        localStorage.setItem("userId", id);
        localStorage.setItem("companyDueDate", vencimento);

        if(window.self !== window.top){
          console.log("ver o valor de queuename ", localStorage.getItem("queueName"));
          const queueUserId = data.user.queues.find((q) => q.name === localStorage.getItem("queueName"));

          console.log("ver o valor de queueueserid", queueUserId);

          console.log("antes do mobilephone ", localStorage.getItem("mobilephone"));
          if(localStorage.getItem("mobilephone") !== "" && localStorage.getItem("mobilephone") !== null) {
            console.log("entrei no getitem mobilephone");
            const dataUserInfo = await api.get(`/users/${id}`);
            console.log("ver o valor de datauserInfo ", dataUserInfo);
            const whatsUserInfo = dataUserInfo.data.whatsappId;
            localStorage.setItem("whatsid", dataUserInfo.data.whatsappId);
    
            const newValuesTeste = {
              name: localStorage.getItem("contacName"),
              number: localStorage.getItem("mobilephone"),
              companyId: companyId
            }
    
            const dataUserInfo2 = await api.get("/contacts/verify", {
              params: {
                name: newValuesTeste.name,
                number: newValuesTeste.number,
                companyId: newValuesTeste.companyId
              }
            });
  
            localStorage.setItem("companyexternal", newValuesTeste.companyId);
            localStorage.setItem("contactexternal", dataUserInfo2.data.id);
    
            const getTicketInfo = await api.get(`/tickets/external/${dataUserInfo2.data.id}`);
      
            if (getTicketInfo?.data && getTicketInfo.data !== null) {
              localStorage.setItem("ticket_uuid", getTicketInfo.data.uuid);
    
              if (getTicketInfo.data.status === "closed") {
                await api.put(`/tickets/${getTicketInfo.data.id}`, {
                  contactId: dataUserInfo2.data.id,
                  status: "open",
                  userId: id,
                  companyId: newValuesTeste.companyId,
                  queueId: queueUserId.id,
                  whatsappId: whatsUserInfo,
                })
              }
            } else {
    
              await api.post("/tickets", {
                contactId: dataUserInfo2.data.id,
                status: "open",
                userId: id,
                companyId: newValuesTeste.companyId,
                queueId: queueUserId.id,
                whatsappId: whatsUserInfo,
              });
    
              const showContactInfo = await api.get(`/tickets/external/${dataUserInfo2.data.id}`);
              localStorage.setItem("ticket_uuid", showContactInfo.data.uuid);
  
              const sendTokenToParent = (token, expiresIn, whatsappId, userId, companyId, contactId, status, queueId) => {
                console.log("Preparando para enviar AUTH_TOKEN ao Dynamics:");
                console.log("Dados enviados:", {
                  token,
                  expiresIn,
                  whatsappId,
                  userId,
                  companyId,
                  contactId,
                  status,
                  queueId,
                });
              
                try {
                  // Envia o token e validade via postMessage
                  window.opener.postMessage(
                    {
                      type: "AUTH_TOKEN",
                      token: token,
                      expiresIn: expiresIn, // Tempo de validade em segundos
                      whatsappId: whatsappId,
                      userId: userId,
                      companyId: companyId,
                      contactId: contactId,
                      statusId: status,
                      queueId: queueId,
                    },
                    "*"
                  );
                  console.log("AUTH_TOKEN enviado com sucesso ao Dynamics.");
                } catch (error) {
                  console.log("Erro ao enviar AUTH_TOKEN:", error);
                }
              
                // Fecha a janela de login
                console.log("Fechando a janela de login.");
                window.close();
              };
              
              const currentToken = localStorage.getItem("token");
              const expireTimeToken = 5 * 24 * 60 * 60;
              const externalWhatsid = whatsUserInfo;
              const externalUserid = id;
              const externalCompanyid = newValuesTeste.companyId;
              const externalContactid = dataUserInfo2.data.id;
              const externalStatus = "open"
              const externalQueue = queueUserId.id;           
  
              sendTokenToParent(currentToken, expireTimeToken, externalWhatsid, externalUserid, externalCompanyid, externalContactid, externalStatus, externalQueue);  
            }        
          }              


          const sendTokenToParent2 = (token, expiresIn, whatsappId, userId, companyId, contactId, status, queueId) => {
            console.log("Preparando para enviar AUTH_TOKEN ao Dynamics2:");
            console.log("Dados enviados2:", {
              token,
              expiresIn,
              whatsappId,
              userId,
              companyId,
              contactId,
              status,
              queueId,
            });
          
            try {   
              // Envia o token e validade via postMessage
              window.opener.postMessage(
                {
                  type: "AUTH_TOKEN",
                  token: token,
                  expiresIn: expiresIn, // Tempo de validade em segundos
                  whatsappId: whatsappId,
                  userId: userId,
                  companyId: companyId,
                  contactId: contactId,
                  statusId: status,
                  queueId: queueId,
                },
                "*"
              );
              console.log("AUTH_TOKEN enviado com sucesso ao Dynamics2.");
            } catch (error) {
              console.log("Erro ao enviar AUTH_TOKEN2:", error);
            }
          
            // Fecha a janela de login
            console.log("Fechando a janela de login2.");
            window.close();
          };
          
          const currentToken = localStorage.getItem("token");
          const expireTimeToken = 5 * 24 * 60 * 60;
          const externalWhatsid = localStorage.getItem("whatsid");
          const externalUserid = id;
          const externalCompanyid = localStorage.getItem("companyexternal");
          const externalContactid = localStorage.getItem("contactexternal");
          const externalStatus = "open";
          const externalQueue = queueUserId.id;
  
          console.log(
            "ver os valores enviando para ",
            currentToken, expireTimeToken, externalWhatsid, externalUserid, externalCompanyid, externalContactid, externalStatus, externalQueue
          );
  
          const dataToDynamics = {
            token: localStorage.getItem("token"),
            userid: id,
            companyid: localStorage.getItem("companyexternal"),
            whatsid: localStorage.getItem("whatsid"),
            queueid: queueUserId.id
          }
  
          sendTokenToParent2(currentToken, expireTimeToken, externalWhatsid, externalUserid, externalCompanyid, externalContactid, externalStatus, externalQueue);  
          await api.post("/api/dynamics_data", {          
            token: localStorage.getItem("token"),
            userid: id,
            companyid: localStorage.getItem("companyexternal"),
            whatsid: localStorage.getItem("whatsid"),
            queueid: queueUserId.id
          });
          await api.post("/api/dynamics_data", dataToDynamics);
        }




        api.defaults.headers.Authorization = `Bearer ${data.token}`;
        setUser(data.user);
        setIsAuth(true);
        toast.success(i18n.t("auth.toasts.success"));
        if (Math.round(dias) < 5) {
          toast.warn(`Sua assinatura vence em ${Math.round(dias)} ${Math.round(dias) === 1 ? 'dia' : 'dias'} `);
        }
        history.push("/tickets");

        if(window.self !== window.top) {
          let create_redirectuuid = localStorage.getItem("ticket_uuid")
          history.push(`/dynamics/${create_redirectuuid}`);
        }
        setLoading(false);
      } else {
        toastError(`Opss! Sua assinatura venceu ${vencimento}.
Entre em contato com o Suporte para mais informações! `);
        setLoading(false);
      }

      //quebra linha 
    } catch (err) {
      toastError(err);
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    setLoading(true);

    try {
      await api.delete("/auth/logout");
      setIsAuth(false);
      setUser({});
      localStorage.removeItem("token");
      localStorage.removeItem("companyId");
      localStorage.removeItem("userId");
      localStorage.removeItem("cshow");
      localStorage.removeItem("ticket_uuid");
      localStorage.removeItem("whatsid");

      api.defaults.headers.Authorization = undefined;
      setLoading(false);
      history.push("/login");
    } catch (err) {
      toastError(err);
      setLoading(false);
    }
  };

  const getCurrentUserInfo = async () => {
    try {
      const { data } = await api.get("/auth/me");
      return data;
    } catch (err) {
      toastError(err);
    }
  };

  return {
    isAuth,
    user,
    loading,
    handleLogin,
    handleLogout,
    getCurrentUserInfo,
  };
};

export default useAuth;
